// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2xl-M","content":"RecentSearches_content__3tFG1"};